import { createSlice } from "@reduxjs/toolkit";

const ReviewSlice = createSlice({
    name: "bookReview",
    initialState: {
       editReviewDetails: null,
       allReviews: [],
    },
    reducers: {  
        setReviewDetails: (state, action) => {
            state.editReviewDetails = action.payload;
        },
        setAllReviews: (state:any, action) => {
            state.allReviews = action.payload;
        },
    },
});

export default ReviewSlice.reducer;
export const { setReviewDetails, setAllReviews } = ReviewSlice.actions;
